<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    五和站<br>
站点介绍<br>
五和站为深圳地铁5号线与地铁10号线换乘站，位于深圳龙华区与龙岗区交界，布龙公路与五和大道交叉口南部，布龙路辅道下，沿布龙公路东西方向布站，车站跨路口设置。车站西侧为万科四季花城，北侧为规划绿地，东侧为众多轻工业公司。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:03	23:28	5号线	3分钟	5分25秒<br>
黄贝岭	06:12	23:53	5号线	3分钟	5分25秒<br>
福田口岸	06:09	23:31	10号线	3分40秒	6分钟<br>
双拥街	06:37	23:24	10号线	3分40秒	6分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:21	23:28	5号线	4分钟	6分钟<br>
黄贝岭	06:01	23:53	5号线	4分钟	6分钟<br>
福田口岸	06:14	23:31	10号线	4分50秒	7分钟<br>
双拥街	06:45	23:24	10号线	4分50秒	7分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:21	00:28	5号线	4分钟	6分钟<br>
黄贝岭	06:01	00:53	5号线	4分钟	6分钟<br>
福田口岸	06:10	00:31	10号线	4分50秒	7分钟<br>
双拥街	06:37	00:24	10号线	4分50秒	7分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
五和大道西侧(南)、四季花城<br><br>
B出入口:<br>
布龙路南侧（东）、十二橡树庄园、和磡村<br><br>
C出入口:<br>
五和大道东侧（北）、布龙路北侧（东）<br><br>
D出入口:<br>
五和大道西侧（北）、布龙路北侧（西）、坂田派出所<br><br>
H出入口:<br>
五和大道东侧(南)、和磡村<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 四季花城①<br>
328、612、M263、M383、M491、M137、M271、M521、高峰专线91号、M173<br><br>
A出入口:<br>
公交站名： 四季花城②<br>
M533、M282、M448、E22、M346、高快巴士41<br><br>
H出入口:<br>
公交站名： 四季花城①<br>
M173<br><br>
H出入口:<br>
公交站名： 四季花城②<br>
M271、M385、M461、612、E22、M263、M282、M383、M448、M491、M533、M521、M346、M137、高峰专线91号、328、B686<br><br>
C出入口:<br>
公交站名： 五和地铁站<br>
612、M263、M271、M346、M383、M461、M491、M521、982、M137、M342、M566<br><br>
D出入口:<br>
公交站名： 五和地铁站北<br>
M398、M415、M173<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shihaoxian",
          title: "10号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


